import React, { useState, useRef } from 'react';
import { Message } from 'semantic-ui-react';
import SlideInPanel from '../SlideInPanel';
import { LitGroupProfileForm } from '../../bookWorksheet/components/forms';
import { useSharedData } from '../../bookWorksheet/hooks/core/useZoneHooks';
import myLibrary from '../../assets/myLibrary.svg'

/**
 * AddLiteraryGroupPanel Component
 * Panel for creating a new literary group
 */
const AddLiteraryGroupPanel = ({ isOpen, onClose, onSuccess }) => {
  const sharedData = useSharedData();
  const litGroupFormRef = useRef();

  // State
  const [newGroupId] = useState(crypto.randomUUID());
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  // Get actions from shared data
  const {
    setLitGroupSelection,
    fetchBooks,
    fetchLitGroups
  } = sharedData.actions;

  // Handle save
  const handleSaveProfile = async (updatedProfile) => {
    try {
      setIsSaving(true);

      // After successful save
      if (updatedProfile && updatedProfile.uuid) {
        // Set the selection to the new group
        setLitGroupSelection(updatedProfile.uuid);

        // Fetch books for the new group
        fetchBooks(updatedProfile.uuid, true);

        // Refresh literary groups list
        await fetchLitGroups();

        // Show success message
        setSuccessMessage('Literary group created successfully');

        // Call success callback if provided
        if (onSuccess) {
          onSuccess(updatedProfile);
        }

        // Close panel after a short delay
        setTimeout(() => {
          onClose();
          setSuccessMessage('');
        }, 1500);
      }
    } catch (error) {
      console.error('Error creating literary group:', error);
      setErrorMessage('Failed to create literary group');
      setTimeout(() => setErrorMessage(''), 5000);
    } finally {
      setIsSaving(false);
    }
  };

  // Handle panel close
  const handleClose = () => {
    if (!isSaving) {
      setSuccessMessage('');
      setErrorMessage('');
      onClose();
    }
  };

  return (
    <SlideInPanel
      isOpen={isOpen}
      onClose={handleClose}
      title="Create Literary Group"
      width="700px"
      headerImg={myLibrary}
    >
      {successMessage && (
        <Message positive>
          <Message.Header>Success</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <div style={{ padding: '1rem 0' }}>
        <LitGroupProfileForm
          ref={litGroupFormRef}
          onSave={handleSaveProfile}
          selectedLitGroupProfile={null}
          litGroupId={newGroupId}
          isPanel={true}
        />
      </div>
    </SlideInPanel>
  );
};

export default AddLiteraryGroupPanel;
